<div class="table">
  <slot></slot>
</div>  

<style>
  .table {
    background: rgb(204, 204, 204);

    padding: 2% 3%;

    display: flex;
    flex-direction: column;
  }
</style>